export default __webpack_public_path__ + "static/SEO_future_academy-7416064283d06337861c2c25450028e3.png";